import { Container } from "@mui/material";
import {
  ClinicianProvider,
  Footer,
  Header,
} from "./components";
import {
  Calculator,
  Calculators,
  ClinicianProfile,
  Dashboard,
  PatientProfile,
  Questions,
  RedFlagsChecklist,
} from "./pages";
import styled from "@emotion/styled";
import { Outlet, RouterProvider, createBrowserRouter } from "react-router-dom";

const AppContainer = styled(Container)({
  padding: "2rem 1rem",
});

const ScreenContainer = styled("div")({
  display: "flex",
  minHeight: "100vh",
  flexDirection: "column",
});

const App = () => {
  return <RouterProvider router={router} />;
};

const Root = () => (
  <ClinicianProvider>
    <ScreenContainer>
      <Header />
      <AppContainer>
        <Outlet />
      </AppContainer>
      <Footer />
    </ScreenContainer>
  </ClinicianProvider>
);

const router = createBrowserRouter([
  {
    path: "/",
    element: <Root />,
    children: [
      {
        path: "/",
        element: <Dashboard />,
      },
      {
        path: "red-flags",
        element: <RedFlagsChecklist />,
      },
      {
        path: "questions",
        element: <Questions />,
      },
      {
        path: "calculators",
        element: <Calculators />,
      },
      {
        path: "calculators/:calculatorId",
        element: <Calculator />,
      },
      {
        path: "profile",
        element: <ClinicianProfile />,
      },
      {
        path: "patients/:patientId",
        element: <PatientProfile />,
      },
    ],
  },
]);

export default App;
